import React from "react";

const Link = props => (
  <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
    <defs>
      <filter id="a" width="112.6%" height="134.2%" x="-6.3%" y="-14.8%" filterUnits="objectBoundingBox">
        <feOffset dy={5} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={10} />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0.729411765 0 0 0 0 0.729411765 0 0 0 0 0.729411765 0 0 0 0.35 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect
        width={515}
        height={182}
        x={0.5}
        y={10.5}
        fill="#FFF"
        stroke="currentColor"
        filter="url(#a)"
        rx={4}
        transform="translate(-44 -81)"
      />
      <path
        fill="#FFF"
        stroke="#F2F4F8"
        d="M-10-12.5A3.5 3.5 0 0 0-13.5-9v37a3.5 3.5 0 0 0 3.5 3.5h448a3.5 3.5 0 0 0 3.5-3.5V-9a3.5 3.5 0 0 0-3.5-3.5H-10z"
      />
      <path
        fill="#A5ADBA"
        fillRule="nonzero"
        d="M18.901 1.383l-.285-.286a3.755 3.755 0 0 0-5.305 0l-2.205 2.205a3.726 3.726 0 0 0-1.098 2.653c0 .918.34 1.777.94 2.46l-2.52 2.545c-1.471-1.3-3.717-1.26-5.124.146l-2.205 2.206A3.726 3.726 0 0 0 0 15.964a3.73 3.73 0 0 0 1.099 2.654l.285.286A3.739 3.739 0 0 0 4.037 20c.96 0 1.92-.365 2.652-1.096l2.205-2.206a3.726 3.726 0 0 0 .127-5.152l2.513-2.537a3.736 3.736 0 0 0 2.51.98c.96 0 1.921-.364 2.652-1.095l2.205-2.206A3.726 3.726 0 0 0 20 4.035c0-1.003-.39-1.943-1.099-2.652zM9.158 14.046a2.9 2.9 0 0 1-.854 2.063l-2.205 2.206a2.923 2.923 0 0 1-4.126 0l-.286-.286a2.9 2.9 0 0 1-.854-2.064 2.9 2.9 0 0 1 .854-2.063l2.205-2.206a2.909 2.909 0 0 1 2.063-.853c.675 0 1.344.246 1.887.71l-1.88 1.897a.417.417 0 0 0 .592.587l1.88-1.897c.46.53.724 1.194.724 1.906zm9.154-7.948l-2.205 2.206c-1.094 1.095-2.843 1.123-3.987.113l1.866-1.884a.417.417 0 0 0-.592-.586l-1.86 1.877a2.89 2.89 0 0 1 .16-3.932L13.9 1.686a2.909 2.909 0 0 1 2.063-.853c.746 0 1.494.285 2.063.853l.285.286a2.9 2.9 0 0 1 .855 2.064c0 .779-.303 1.511-.854 2.062z"
      />
    </g>
  </svg>
);

export default Link;
